import React from "react";
import "../Styles/CommitteeMembers.css";

// Import images
import Senthil from "../Assests/senthil.jpeg";
import Santhosh from "../Assests/Santhosh.jpeg";
import Madhu from "../Assests/Madhu.jpeg";
import Sanalg from "../Assests/Sanalg.jpeg";
import Melshanti from "../Assests/Melshanti.jpeg";
import Vishnu from "../Assests/Vishnu.jpeg";
import Ratheesh from "../Assests/Ratheesh.jpeg";
import shylaja from "../Assests/shylaja.jpeg";
import sasi from "../Assests/sasi.jpeg";
import monish from "../Assests/monish.jpeg";
import siju from "../Assests/siju.jpeg";
import eashu1 from "../Assests/eashu1.jpeg";
import Ramalekshmi from "../Assests/Ramalekshmi.jpeg";
import Sankaran from "../Assests/Sankaran.jpeg";
import Rajendar from "../Assests/Rajendar.jpeg";
import Arunmosad from "../Assests/Arunmosad.jpeg";
import Vasu from "../Assests/vasu.jpeg";
import Bharathan from "../Assests/bharathan.jpeg";
import Rakesh from "../Assests/Rakesh.jpeg";
import Anithadevi from "../Assests/Anithadevi.jpeg";
import Narayanan from "../Assests/Narayanan.jpeg";

const committeeMembers = [
  { id: 3, name: "Sri. Madhu P.", designation: "Rakshadhikari", image: Madhu },
  { id: 1, name: "Sri. SanalKumar M.C.", designation: "President", image: Sanalg },
  { id: 2, name: "Sri. Saseendran Nair", designation: "VicePresident", image: sasi },
  { id: 3, name: "Sri. SanthoshKumar V.N.", designation: "Secretary", image: Santhosh },
  { id: 4, name: "Sri. SenthilKumar S", designation: "Treasurer", image: Senthil },
  { id: 5, name: "Sri. Ratheesh M.N.", designation: "Joint Treasurer", image: Ratheesh },
  { id: 6, name: "Sri. Bharath M.A.", designation: "Committee Member", image: Bharathan },
  { id: 7, name: "Sri. Monish", designation: "Committee Member", image: monish },
  { id: 8, name: "Sri. Siju", designation: "Committee Member", image: siju },
  { id: 9, name: "Sri. Vishnu", designation: "Committee Member", image: Vishnu },
  { id: 10, name: "Sri.Sankaran", designation: "Committee Member", image: Sankaran },
  { id: 10, name: "Sri.Narayanan", designation: "Committee Member", image: Narayanan },
  { id: 11, name: "Smt. Ramalekshmi S", designation: "Committee Member", image: Ramalekshmi },
  { id: 12, name: "Smt. Parameshwari K", designation: "Committee Member", image: eashu1 },
  { id: 13, name: "Smt. Sailaja S Nair", designation: "Committee Member", image: shylaja },
  { id: 13, name: "Smt. AnithaDevi", designation: "Committee Member", image: Anithadevi }
];

// 5 Bottom Members assigned to their corresponding headers
const bottomSectionMembers = [
  {
    id: 1,
    category: "Temp Than",
    name: "Brahmasri Vezhaparambu Chithrabhanu Namboothiri",
  
    image: Melshanti
  },
  {
    id: 2,
    category: "Temp Than",
    name: "Brahmasri Vasudevan Namboothiri",
   
    image: Vasu
  },
  {
    id: 4,
    category: "Guruthi",
    name: "Sri. Arun Moosad",
    
    image: Arunmosad
  },
  {
    id: 3,
    category: "Guruthi",
    name: "Sri. Rajendran Moosad",
    
    image: Rajendar
  },
  
  {
    id: 5,
    category: "Samb",
    name: "Sri. Thrikkapuram Rakesh",
   
    image: Rakesh
  }
];

function CommitteeMembers() {
  return (
    <div className="committee-page">
      {/* Upper Section Header */}
      <div className="committee-header">
        <h1>Photo Gallery</h1>
      </div>

      {/* 5-Column Grid Layout for Top Members */}
      <div className="committee-container grid-5">
        {committeeMembers.map((member) => (
          <div className="member-card" key={member.id}>
            <div className="member-image-container">
              <img src={member.image} alt={member.name} className="member-image" />
            </div>
            <div className="member-details">
              <h2>{member.name}</h2>
              <p>{member.designation}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Bottom Section Headers Spanned Across 5 Columns */}
      <div className="bottom-section-container">
        <div className="bottom-headers-grid">
          <h2 className="header-span-2">Kshethram Thanthrikal</h2>
          <h2 className="header-span-2">Saktheya Guruthi Poojakar</h2>
          <h2 className="header-span-1">Kshethram Sambandhi</h2>
        </div>

        {/* Bottom 5 Photo Cards evenly divided in a 5-column layout */}
        <div className="committee-container grid-5">
          {bottomSectionMembers.map((member) => (
            <div className="member-card" key={member.id}>
              <div className="member-image-container">
                <img src={member.image} alt={member.name} className="member-image" />
              </div>
              <div className="member-details">
                <h2>{member.name}</h2>
                <p>{member.designation}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CommitteeMembers;